'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom,
  flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'

Polymer({
  is: 'moskito-publishers-manager',
  properties: {
    data: {
      type: Object,
      notify: true,
      reflectToAttribute: true,
      readOnly: false
    },
    lang: {
      type: Object,
      notify: true
    },
    publishers: {
      type: Array,
      notify: true
    },
    url: {
      type: String,
      notify: true
    }
  },
  ready: function () {},
  handleResponse: function () {
    this.$.tpl.render()
  },
  handlePercentages: function () {
    let pa = document.querySelectorAll('.percentage')
    let total = 0;
    [].forEach.call(pa, function (item) {
      total += Math.round(item.value * 100) / 100
    })
    document.querySelector('#total_percentage').value = Math.round(total)
  },
  openDialog: function () {
    this.$.dialog.open()
  },
  filterPublishers: function (val) {
    return function (publisher) {
      if (!val) return true
      if (!publisher) return false
      return (publisher.name && ~publisher.name.indexOf(removeDiacritics(val).toUpperCase()))
    }
  },
  updatePublishersTree: function (e) {
    this.data.selected_publishers_ids = {
      'ids[]': e.target.selectedValues
    }
    this.$.first.params = this.data.selected_publishers_ids
    this.data = {
      'url': this.data.url,
      'selected_publishers_ids': this.data.selected_publishers_ids
    }
  }
})
